module.exports = __webpack_public_path__ + "static/img/icon_call.744e8f4b.svg";